import React, { useState } from "react";
import { useApp } from "../context/AppContext";
import Card from "../components/ui/Card";
import { fmt } from "../utils/helpers";

const FILTERS = [
  { key: "all", label: "Tout" },
  { key: "credit", label: "Crédit", icon: "fa-mobile-alt" },
  { key: "transfer", label: "Transfert", icon: "fa-exchange-alt" },
  { key: "receive", label: "Reçu", icon: "fa-arrow-down" },
];

const TX_STYLE = {
  credit:   { bg: "#fff7f0", color: "#FF6200", icon: "fa-mobile-alt" },
  transfer: { bg: "#f0f7ff", color: "#005B8E", icon: "fa-exchange-alt" },
  receive:  { bg: "#f0fdf4", color: "#16a34a", icon: "fa-arrow-down" },
};

export default function History() {
  const { transactions } = useApp();
  const [filter, setFilter] = useState("all");

  const filtered =
    filter === "all" ? transactions : transactions.filter((t) => t.type === filter);

  return (
    <div className="bg-[#f0f2f7] pb-2 screen-enter">
      {/* Header */}
      <div className="bg-brand-dark px-[17px] pt-[14px] pb-[17px]">
        <h2 className="text-white text-[17px] font-bold mb-0.5">Historique</h2>
        <p className="text-white/60 text-[11px]">Toutes vos transactions</p>
      </div>

      <div className="p-3">
        {/* Filtres */}
        <div className="flex gap-[5px] mb-3 overflow-x-auto hide-scrollbar pb-0.5">
          {FILTERS.map(({ key, label, icon }) => {
            const sel = filter === key;
            return (
              <button
                key={key}
                onClick={() => setFilter(key)}
                className="cursor-pointer border rounded-[18px] px-3 py-[5px] text-[11px] font-bold whitespace-nowrap tap-highlight transition-all flex-shrink-0"
                style={{
                  borderColor: sel ? "#FF6200" : "#e5e7eb",
                  color: sel ? "#FF6200" : "#6b7280",
                  background: sel ? "#fff7f0" : "white",
                  borderWidth: 1.5,
                }}
              >
                {icon && <i className={`fa ${icon} mr-1`} style={{ fontSize: 9 }} />}
                {label}
              </button>
            );
          })}
        </div>

        {/* Liste */}
        <Card padding={false}>
          {filtered.length === 0 ? (
            <div className="px-4 py-4 text-center text-xs text-gray-400">
              Aucune transaction
            </div>
          ) : (
            filtered.map((tx, i) => {
              const s = TX_STYLE[tx.type] || TX_STYLE.credit;
              const sub =
                tx.payPhone &&
                tx.recPhone &&
                tx.payPhone !== "Rechargement" &&
                tx.payPhone !== "Virement reçu"
                  ? `${tx.payPhone} → ${tx.recPhone}`
                  : tx.payPhone;
              return (
                <div
                  key={i}
                  className={`px-3 py-2.5 flex items-center gap-[9px] ${
                    i < filtered.length - 1 ? "border-b border-gray-100" : ""
                  }`}
                >
                  <div
                    className="w-8 h-8 rounded-[9px] flex items-center justify-center flex-shrink-0"
                    style={{ background: s.bg }}
                  >
                    <i className={`fa ${s.icon}`} style={{ color: s.color, fontSize: 12 }} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-xs font-semibold text-brand-dark truncate">{tx.label}</p>
                    <p className="text-[10px] text-gray-400 truncate">{sub}</p>
                    <p className="text-[10px] text-gray-300">
                      {tx.date} · {tx.time}
                    </p>
                  </div>
                  <span
                    className="text-xs font-bold flex-shrink-0 whitespace-nowrap"
                    style={{ color: tx.amount < 0 ? "#dc2626" : "#16a34a" }}
                  >
                    {tx.amount < 0 ? "-" : "+"}{fmt(tx.amount)}
                  </span>
                </div>
              );
            })
          )}
        </Card>
      </div>
    </div>
  );
}
